export default __webpack_public_path__ + "static/media/unique-visuals.b2c5bac0.svg";